const RELEASE_MODE = true;

const Config = {
    RELEASE_MODE
};
  
export default Config;